import { render, staticRenderFns } from "./DashboardSideMenu.vue?vue&type=template&id=c4e763d4&"
import script from "./DashboardSideMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports